import React from 'react';

export function EnergyIconAFD() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 91.15 52.45">
            <defs>
                <style>
                    {`
                        .cls-1-d {
                            stroke-width: .82px;
                        }

                        .cls-1-d, .cls-2-d, .cls-3-d {
                            stroke: #231f20;
                            stroke-linecap: round;
                            stroke-linejoin: round;
                        }

                        .cls-1-d, .cls-3-d {
                            fill: none;
                        }

                        .cls-4-d {
                            font-size: 18.42px;
                        }

                        .cls-4-d, .cls-5-d {
                            fill: #231f20;
                            font-family: Calibri-Bold, Calibri;
                            font-weight: 700;
                        }

                        .cls-6-d {
                            fill: #fdb913;
                        }

                        .cls-6-d, .cls-7-d {
                            stroke-width: 0px;
                        }

                        .cls-5-d {
                            font-size: 10px;
                        }

                        .cls-2-d {
                            stroke-width: .5px;
                        }

                        .cls-2-d, .cls-7-d {
                            fill: #fff;
                        }

                        .cls-3-d {
                            stroke-width: 1.07px;
                        }
                    `}
                </style>
            </defs>
            <g id="D">
                <rect className="cls-7-d" x="69.5" y=".73" width="21.33" height="49" />
                <polygon className="cls-6-d" points="22.62 .77 .29 25.06 22.62 49.35 71.62 49.35 71.62 .77 22.62 .77" />
                <path
                    className="cls-1-d"
                    d="M23.1.41h67.27c.2,0,.36.16.36.36v48.58c0,.2-.16.36-.36.36H23.1c-.1,0-.2-.04-.26-.12L.5,25.3c-.13-.14-.13-.35,0-.48L22.84.52c.07-.07.16-.12.26-.12Z"
                />
                <path
                    className="cls-2-d"
                    d="M55.89,25.6c0,2.2-.27,4.09-.8,5.65-.53,1.57-1.3,2.84-2.29,3.83-1,.99-2.21,1.72-3.63,2.18s-3.12.7-5.09.7h-5.3c-.38,0-.69-.12-.95-.36s-.39-.63-.39-1.18V15.49c0-.54.13-.94.39-1.18s.57-.36.95-.36h5.7c1.98,0,3.66.25,5.04.75,1.38.5,2.54,1.24,3.48,2.23.94.98,1.66,2.2,2.15,3.65.49,1.45.74,3.13.74,5.03ZM51.22,25.77c0-1.14-.12-2.2-.37-3.17-.25-.98-.64-1.83-1.18-2.54-.54-.72-1.24-1.28-2.09-1.68-.85-.4-1.97-.6-3.35-.6h-2.28v16.34h2.35c1.24,0,2.28-.17,3.12-.52.85-.35,1.55-.87,2.12-1.57s.99-1.57,1.27-2.61c.28-1.04.42-2.25.42-3.64Z"
                />
            </g>
            <g id="Layer_11" data-name="Layer 11">
                <g>
                    <line className="cls-3-d" x1="81.33" y1="30.37" x2="81.33" y2="20.01" />
                    <polyline className="cls-3-d" points="84.08 22.71 81.33 19.96 78.59 22.71" />
                </g>
                <text className="cls-4-d" transform="translate(76.62 45.94) scale(1 1.01)">
                    <tspan x="0" y="0">
                        F
                    </tspan>
                </text>
                <text className="cls-4-d" transform="translate(74.84 15.94) scale(1 1.01)">
                    <tspan x="0" y="0">
                        A
                    </tspan>
                </text>
                <text className="cls-5-d" transform="translate(83.5 9.24) scale(1 1.01)">
                    <tspan x="0" y="0">
                        +
                    </tspan>
                </text>
            </g>
        </svg>
    );
}
